module.exports = __webpack_public_path__ + "static/media/exampleCover.339df025.jpg";